export default __webpack_public_path__ + "static/media/yuduRobotics.c58b905e.png";